<template>
  <v-layout column class="date-picker-container" :class="{required: isRequired}">
    <span v-if="outsideLabel" class="list-label">
      {{ outsideLabel }}
    </span>
    <v-menu
      :close-on-click="true"
      v-model="isMenuOpen"
      v-bind="menuProps"
      :close-on-content-click="false"
      content-class="date-picker-menu-content"
      :offset-y="true"
    >
      <template v-slot:activator="{ on, attrs }">
        <VcitaTextField
          v-click-outside="closeMenu"
          class="date-picker-text-input"
          data-qa="date-picker-text-input"
          ref="textInput"
          v-bind="{...attrs}"
          :label="label || $t('common.datepicker.date')"
          :value="computedDateFormatted"
          :prepend-inner-icon="!removeIcon ? 'icon-Calendar' : ''"
          color="rgba(0, 0, 0, 0.4)"
          autocomplete="off"
          readonly
          clear-icon="far fa-times-circle"
          v-on="{...on}"
        >

        </VcitaTextField>
        <VcitaTextField
          :value="computedValue"
          v-bind="$attrs"
          class="hidden-date-value"
        >

        </VcitaTextField>
      </template>
      <v-date-picker
        ref="datePicker"
        no-title
        :min="notBefore"
        class="date-picker-comp"
        v-bind="$attrs"
        :color="brandBgColor"
        width="292px"
        show-adjacent-month
        :value="computedValue"
        v-on="$listeners"
        @input="isMenuOpen = false"
      >
      </v-date-picker>
      <div class="switch-container"
        v-if="allDayEnable">
        <VcitaSwitch
          :class="'switch-toggle'"
          :ripple="false"
          v-model="isSwitchOn"
          @input=" val => $emit('toggle', !!val)"
          :label="$t('calendar.widget.all_day_c')">
        </VcitaSwitch>
      </div>
    </v-menu>
  </v-layout>
</template>

<script>
  import VcitaTextField from "@/modules/common/components/VcitaTextField/VcitaTextField.vue"
  import VcitaSwitch from "@/modules/common/components/VcitaSwitch/VcitaSwitch.vue"
  import moment from "moment";
  import ClickOutside from 'vue-click-outside'

  export default {
    components: {
      VcitaTextField,
      VcitaSwitch
    },
    directives: {
      ClickOutside
    },
    props: {
      menuProps: {
        type: Object,
        default: () => ({})
      },
      outsideLabel: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      value: {
        type: String,
        required: true,
      },
      notBefore: {
        type: String,
        default: ''
      },
      allDayEnable: {
        type: Boolean,
        default: false
      },
      removeIcon: {
        type: Boolean,
        default: false
      },
      switchOn: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isMenuOpen: false,
        isSwitchOn: this.switchOn
      }
    },
    methods:{
      emitTextInput(e) {
        const newVal = moment(e.target.value).format('YYYY-MM-DD');
        this.$emit('input', newVal)
      },
      closeMenu(e) {
        let elem = e.target.closest('.v-picker--date, .switch-toggle')
        if (!elem)
          this.isMenuOpen = false
      },
      openMenu() {
        this.isMenuOpen = true
        this.popupItem.click()
      }
    },
    watch: {
      switchOn: {
        async handler(newVal) {
          this.isSwitchOn = newVal
        }
      }
    },
    computed: {
      isRequired() {
        return [false, undefined].indexOf(this.$attrs.required) === -1
      },
      computedValue() {
        return moment(this.value || new Date().toISOString())
          .format('YYYY-MM-DD');
      },
      computedDateFormatted() {
        if (!this.value) return ''
        return moment(this.value)
          .format('DD MMM YYYY');
      },
      brandBgColor() {
        return this.$store && this.$store.getters['brandModule/secondaryColor'];
      },
      popupItem() {
        return this.$refs.datePicker && this.$refs.datePicker.$el
      }
    }
  }
</script>

<style lang="scss" >
  .date-picker-menu-content {
    min-width: unset !important;
    background-color: #ffffff;

    .date-picker-comp {
      border-radius: 6px;
      box-shadow: unset;
    }
    .v-date-picker-header__value {
      font-family: var(--primary-font-family);
      font-size: 14px;
      color: rgba(3, 3, 3, 0.87);
    }
    .v-date-picker-table {
      height: unset;
      padding: 0 13px;
      padding-bottom: 14px;
      thead {
        font-family: var(--primary-font-family);
        line-height: 1.33;
      }
      tbody {
        font-family: var(--primary-font-family);
        tr {
          td {
            padding: 2px 3px;
            button  {
              div {
                font-weight: normal;
              }
            }
          }
        }
      }
    }

    .switch-container {
      height: 48px;
      padding: 12px 24px;
      background: rgba(0, 0, 0, 0.03);
    }
  }
  .date-picker-container {
    .hidden-date-value {
      visibility: hidden;
      max-height: 0;
    }
    .date-picker-text-input {
      &.v-input.v-text-field.theme--light.v-text-field--outlined {
        color: rgba(0, 0, 0, 0.12);
        fieldset {
          color: inherit;
        }
      }
    }
    i {
      color: rgba(0, 0, 0, 0.38);
    }
    .list-label {
      font-family: var(--primary-font-family);
      font-size: 12px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.54);
    }
    &.required {
      label::after, .list-label::after {
        content: "*";
        font-size: 12px;
        font-weight: 600;
        color: #f2514a;
        margin: 0 2px;
      }
    }

  }
  .date-picker-text-input {
    .v-input__slot {
      min-height: 52px !important;
      border-radius: 6px;
      background-color: #fff !important;
    }
    input {
      font-family: var(--primary-font-family);
      font-size: 15px !important;
      font-weight: 500;
      &::placeholder {
        font-family: var(--primary-font-family);
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: rgba(0, 0, 0, 0.4);
      }
    }
    .v-input__prepend-inner, .v-input__append-inner {
      margin-top: auto;
      margin-bottom: auto;
    }
    .v-input__slot {
      padding: 0 !important;
    }
    .v-input__prepend-inner  {
      i {
        font-size: 17.5px;
      }

    }
  }

</style>
